@if (view$ | async; as view) {
    <div class="container-fluid mt-3">
        <form
            [formGroup]="view.formGroup"
            class="mt-3 mb-3 mx-auto"
            (submit)="submit(view.buildingNo)">
            <div class="row">
                <div class="col-lg-6 col-md-12">
                    <!-- Agent name and consumption period-->
                    <div class="card mb-3">
                        <div class="card-body">
                            <app-input-text-group
                                [trim]="true"
                                [markTouchedOnChange]="false"
                                [formControl]="view.formGroup.controls.agentName"
                                [information]="
                                    'consumption-agents_create_agent_name_description' | translate
                                "
                                [label]="'monitoring_agentName' | translate" />
                            <app-input-number-group
                                [formControl]="view.formGroup.controls.dayCount"
                                [information]="
                                    'consumption-agents_create_consumption_period_description'
                                        | translate
                                "
                                [label]="'monitoring_consumption-period_days' | translate"
                                [maxlength]="3" />
                        </div>
                    </div>

                    <!-- Choose consumption-/monitoring type -->
                    <div class="card mb-3">
                        <div class="card-body">
                            <div class="mb-3">
                                <app-consumption-agent-monitoring
                                    [formGroup]="view.formGroup.controls.monitoringFormGroup" />
                            </div>

                            @if (
                                view.formGroup.value.monitoringFormGroup?.consumptionToMonitor !==
                                'INDIVIDUALCONSUMPTION'
                            ) {
                                <app-checkbox-group
                                    [formControl]="view.formGroup.controls.showConsumptionForMeters"
                                    [label]="
                                        'monitoring_show-consumption-for-individual-meters'
                                            | translate
                                    "
                                    [information]="
                                        'consumption-agents_create_show_consumption_for_individual_meters_description'
                                            | translate
                                    " />
                            }
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 col-md-12 mb-3">
                    <!-- Investigation -->
                    <div class="card mb-3">
                        <div class="card-body">
                            <app-consumption-agent-investigation
                                [formGroup]="view.formGroup.controls.investigationFormGroup"
                                [consumptionToMonitor]="
                                    view.formGroup.controls.monitoringFormGroup.controls
                                        .consumptionToMonitor.value
                                "
                                [outputUnitTranslated]="view.outputUnitTranslated" />
                        </div>
                    </div>

                    <!-- Scheduling -->
                    <div class="card">
                        <div class="card-body">
                            <app-input-select-option-group
                                [formControl]="view.formGroup.controls.schedule"
                                [label]="'monitoring_notification_scheduler' | translate"
                                [data]="view.schedulerMap"
                                [information]="
                                    'consumption-agents_create_scheduler_description' | translate
                                "
                                sortOrder="desc" />

                            @if (view.formGroup.controls.schedule.value !== 'DISABLED') {
                                <app-input-email-list
                                    [label]="'monitoring_e-mails' | translate"
                                    formControlName="recipients"
                                    [information]="
                                        'consumption-agents_create_emails_description' | translate
                                    " />

                                <app-checkbox-group
                                    [label]="'monitoring_send-empty-reports' | translate"
                                    [formControl]="view.formGroup.controls.sendBlank"
                                    [information]="
                                        'consumption-agents_create_send_empty_reports_description'
                                            | translate
                                    " />
                            }
                        </div>
                    </div>
                </div>

                <!-- Back, reset and submit buttons -->
                <div class="text-end me-3">
                    <button
                        class="btn btn-outline-primary"
                        type="button"
                        [routerLink]="[
                            '/admin/system',
                            view.buildingNo,
                            'monitoring',
                            'consumption-agents',
                        ]">
                        {{ 'utilities_.BACK' | translate }}
                    </button>

                    <button class="btn btn-outline-primary mx-1" type="button" (click)="reset()">
                        {{ 'utilities_reset' | translate }}
                    </button>
                    <button
                        class="btn btn-outline-primary me-1"
                        type="button"
                        (click)="openPreviewModal(view.formGroup)">
                        {{ 'reportagent_SHOW_REPORT' | translate: 'online' : 'reportagent' }}
                    </button>
                    <button class="btn btn-primary" type="submit">
                        {{ 'actions_save' | translate: 'online' : 'common' }}
                    </button>
                </div>
            </div>
        </form>
    </div>
} @else {
    <app-load />
}
